export const registerNotifications = () => `api/NotificationConfig/Register`;

export const getAllTemplateNotifications = () => `api/Notification`;

export const getTemplateNotificationById = (templateId: number) =>
  `api/Notification/Template/${templateId}`;

export const notificationSubscription = () => "api/Notification/Subscription";

export const resolveNotification = () => "/api/Notification";
